// extracted by mini-css-extract-plugin
export default {"banner":"WalletBanner_banner__fBZW-","btn":"WalletBanner_btn__BEAMo"};